import { render, staticRenderFns } from "./CmgIngredientPanel.vue?vue&type=template&id=8957b6de&scoped=true&lang=pug&"
import script from "./cmg-ingredient-panel.ts?vue&type=script&lang=ts&"
export * from "./cmg-ingredient-panel.ts?vue&type=script&lang=ts&"
import style0 from "./CmgIngredientPanel.vue?vue&type=style&index=0&id=8957b6de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8957b6de",
  null
  
)

export default component.exports